import { render, staticRenderFns } from "./depositRequestModal.vue?vue&type=template&id=795b8a5a&scoped=true"
import script from "./depositRequestModal.vue?vue&type=script&lang=js"
export * from "./depositRequestModal.vue?vue&type=script&lang=js"
import style0 from "./depositRequestModal.vue?vue&type=style&index=0&id=795b8a5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "795b8a5a",
  null
  
)

export default component.exports